import {LayoutComponent} from '../layout/layout.component';
import {LoginComponent} from './pages/login/login.component';
import {PasswordComponent} from './pages/password/password.component';
import { Routes } from "@angular/router";

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      {path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule)},
      {path: 'administration', loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule)},
      {path: 'report', loadChildren: () => import('./report/report-manager.module').then(m => m.ReportManagerModule)},
      {path: 'drug', loadChildren: () => import('./drug/drug-manager.module').then(m => m.DrugManagerModule)},
      {path: 'congress', loadChildren: () => import('./congress/congress.module').then(m => m.CongressModule)},
      {path: 'vaccine', loadChildren: () => import('./vaccine/vaccine.module').then(m => m.VaccineModule)}
    ]
  },

  // Not lazy-loaded routes
  {path: 'login', component: LoginComponent},
  {path: 'password', component: PasswordComponent},

  // Not found
  {path: '**', redirectTo: 'home'}

];
